// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3ybeN","box":"WorkspacesBox_box__3wIyi","node":"WorkspacesBox_node__2w0Yb"};